import type { SlideHotspot } from "../../types"

function hotspotAriaLabel(
  link: SlideHotspot,
  jumpLabel: (n: number) => string,
  lastViewedLabel: string
): string {
  switch (link.kind) {
    case "last_viewed":
      return lastViewedLabel
    case "slide":
      return jumpLabel(link.target_index + 1)
    default: {
      const _exhaustive: never = link
      return _exhaustive
    }
  }
}

export interface SlideLinkHotspotsProps {
  links: SlideHotspot[]
  enabled: boolean
  jumpLabel: (n: number) => string
  lastViewedLabel: string
  onActivate: (link: SlideHotspot) => void
}

/**
 * Transparent hit targets over the slide stage. Coordinates are normalized
 * 0..1 against the slide box (same space as annotations / laser).
 */
export function SlideLinkHotspots({
  links,
  enabled,
  jumpLabel,
  lastViewedLabel,
  onActivate,
}: SlideLinkHotspotsProps) {
  if (!enabled || links.length === 0) return null
  return (
    <>
      {links.map((link, index) => (
        <button
          key={`${link.kind}-${index}-${link.x}-${link.y}`}
          aria-label={hotspotAriaLabel(link, jumpLabel, lastViewedLabel)}
          className="absolute z-[45] cursor-pointer border-0 bg-transparent p-0"
          data-link-kind={link.kind}
          data-testid="presentation-slide-link"
          type="button"
          style={{
            height: `max(${link.h * 100}%, 28px)`,
            left: `${link.x * 100}%`,
            minHeight: 28,
            minWidth: 28,
            top: `${link.y * 100}%`,
            width: `max(${link.w * 100}%, 28px)`,
          }}
          onClick={(event) => {
            event.stopPropagation()
            onActivate(link)
          }}
        />
      ))}
    </>
  )
}
